(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1608-about-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('mark-timeline')) return;

    class MarkTimeline extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-mt-slide]'));
        if (!this.slides.length) return;

        this.index = 0;
        this.busy = false;      // tijdens een slide-wissel
        this.snapping = false;  // tijdens het "vastklikken" van de section
        this.fresh = true;      // nieuwe scroll-gebaar (tegen trackpad-inertie)
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.dur = this.reduced ? 120 : (parseInt(this.dataset.duration, 10) || 900);

        this.onWheel = this.onWheel.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchMove = this.onTouchMove.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);
        this.onKey = this.onKey.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.syncVideos = this.syncVideos.bind(this);

        // Lightbox
        this.lb = this.querySelector('[data-mt-lightbox]');
        this.lbVideo = this.lb ? this.lb.querySelector('video') : null;
        this.lbOpen = false;
        this.inView = false;
        if (this.lb) {
          this.lb.addEventListener('close', () => this.onLightboxClose());
          this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.lb.close(); });
        }

        // Achtergrondvideo's alleen afspelen als de section en de slide zichtbaar zijn
        if ('IntersectionObserver' in window) {
          this.viewIo = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
            this.syncVideos();
          });
          this.viewIo.observe(this);
        } else {
          this.inView = true;
        }
        // Mark x of y menu
        this.marks = this.querySelector('[data-mt-marks]');
        this.marksBtn = this.querySelector('[data-mt-marks-toggle]');
        this.currentEl = this.querySelector('[data-mt-current]');
        this.markItems = Array.from(this.querySelectorAll('[data-mt-to]'));
        this.onDocClick = (e) => { if (this.marks && !this.marks.contains(e.target)) this.closeMarks(); };
        document.addEventListener('click', this.onDocClick);

        // Geen content onder de section (header/footer verborgen)? Dan geen "next" op de laatste slide
        this.checkAfter = () => {
          const r = this.getBoundingClientRect();
          const after = document.documentElement.scrollHeight - (r.bottom + window.scrollY);
          this.classList.toggle('mt--no-after', after < 4);
        };
        this.checkAfter();
        window.addEventListener('load', this.checkAfter, { once: true });

        // Na het laden van de pagina alle overige marks alvast inladen (voor snel springen via het menu)
        const idle = window.requestIdleCallback || ((fn) => setTimeout(fn, 1500));
        const loadRest = () => idle(() => this.primeAll());
        if (document.readyState === 'complete') loadRest(); else window.addEventListener('load', loadRest, { once: true });

        // Vaste slash bij de datum
        this.dslash = this.querySelector('[data-mt-dslash]');
        this.onResize = () => this.placeSlash(false);
        window.addEventListener('resize', this.onResize);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.placeSlash(false));

        this.mq = window.matchMedia('(max-width: 749px)');
        if (this.mq.addEventListener) this.mq.addEventListener('change', this.syncVideos);

        window.addEventListener('wheel', this.onWheel, { passive: false });
        this.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.addEventListener('touchmove', this.onTouchMove, { passive: false });
        this.addEventListener('touchend', this.onTouchEnd);
        document.addEventListener('keydown', this.onKey);
        this.addEventListener('click', this.onClick);
        document.addEventListener('shopify:block:select', this.onBlockSelect);

        // Direct linken naar een mark: ?mark=4
        const isEditor = !!(window.Shopify && window.Shopify.designMode);
        const start = isEditor ? this.editorIndex() : this.readMarkParam();
        if (start > 0) {
          this.setInitial(start);
          if (!(window.Shopify && window.Shopify.designMode)) {
            const top = window.scrollY + this.getBoundingClientRect().top;
            if (Math.abs(this.getBoundingClientRect().top) > 2) window.scrollTo(0, top);
          }
        }

        // Intro-animatie zodra de section in beeld komt
        if (window.Shopify && window.Shopify.designMode) {
          this.intro();
        } else if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting)) {
              this.intro();
              this.io.disconnect();
            }
          }, { threshold: 0.25 });
          this.io.observe(this);
        } else {
          this.intro();
        }
      }

      disconnectedCallback() {
        window.removeEventListener('wheel', this.onWheel);
        document.removeEventListener('keydown', this.onKey);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        if (this.io) this.io.disconnect();
        if (this.viewIo) this.viewIo.disconnect();
        document.removeEventListener('click', this.onDocClick);
        window.removeEventListener('resize', this.onResize);
        if (this.mq && this.mq.removeEventListener) this.mq.removeEventListener('change', this.syncVideos);
        clearTimeout(this.t1); clearTimeout(this.t2); clearTimeout(this.idleT);
      }

      /* ---------- Media inladen ---------- */
      // Laadt foto's en video's van een slide expliciet in, zodat het niet afhangt
      // van lazy-loading in de browser of scripts van het theme.
      primeSlide(slide, full) {
        if (!slide || slide.dataset.mtPrimed === (full ? '2' : '1') || slide.dataset.mtPrimed === '2') return;
        slide.dataset.mtPrimed = full ? '2' : '1';
        slide.querySelectorAll('img').forEach((img) => {
          if (img.loading !== 'eager') img.loading = 'eager';
          img.classList.add('lazyloaded', 'loaded', 'is-loaded');
        });
        slide.querySelectorAll('video.mt__video').forEach((v) => {
          if (v.preload === 'none') v.preload = full ? 'auto' : 'metadata';
          if (v.networkState === 3) v.load();
        });
      }

      primeAround() {
        this.primeSlide(this.slides[this.index], true);
        this.primeSlide(this.slides[this.index + 1]);
        this.primeSlide(this.slides[this.index - 1]);
      }

      primeAll() {
        this.slides.forEach((s) => this.primeSlide(s));
      }

      /* ---------- Video ---------- */
      syncVideos() {
        this.primeAround();
        this.slides.forEach((slide, n) => {
          const active = n === this.index && this.introDone;
          slide.querySelectorAll('video.mt__video').forEach((v) => {
            // getClientRects is leeg bij display:none (desktop vs mobiel)
            const shouldPlay = active && this.inView && !this.lbOpen && !this.reduced && v.getClientRects().length > 0;
            if (shouldPlay) {
              v.muted = true;
              if (v.paused) {
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
              }
            } else if (!v.paused) {
              v.pause();
            }
          });
        });
      }

      openLightbox(url, trigger) {
        if (!this.lb || !url) return;
        this.lbTrigger = trigger;
        this.lbOpen = true;
        this.syncVideos();
        this.lbVideo.src = url;
        this.lbVideo.muted = false;
        this.lb.showModal();
        const p = this.lbVideo.play();
        if (p && p.catch) p.catch(() => {});
      }

      onLightboxClose() {
        this.lbVideo.pause();
        this.lbVideo.removeAttribute('src');
        this.lbVideo.load();
        this.lbOpen = false;
        this.syncVideos();
        if (this.lbTrigger && this.lbTrigger.isConnected) this.lbTrigger.focus({ preventScroll: true });
      }

      /* ---------- Vaste slash ---------- */
      // Zet de slash links naast de datum van de actieve mark. Met animate schuift hij erheen.
      placeSlash(animate) {
        const sl = this.dslash;
        if (!sl) return;
        const slide = this.slides[this.index];
        const text = slide && slide.querySelector('.mt__date-text');
        if (!text) { sl.classList.remove('is-placed'); return; }
        const stage = sl.parentElement.getBoundingClientRect();
        const r = text.getBoundingClientRect();
        // SVG heeft geen offsetWidth; maat uit de CSS halen (los van de huidige transform)
        const cs = getComputedStyle(sl);
        const w = parseFloat(cs.width) || 12;
        const h = parseFloat(cs.height) || 24;
        const gap = Math.max(6, w * 0.5);
        const x = r.left - stage.left - w - gap;
        const y = r.top - stage.top + (r.height - h) / 2;
        sl.classList.toggle('no-anim', !animate || !sl.classList.contains('is-placed'));
        sl.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px)';
        void sl.getBoundingClientRect();
        sl.classList.add('is-placed');
        sl.classList.remove('no-anim');
      }

      /* ---------- URL parameter ?mark= ---------- */
      readMarkParam() {
        try {
          const n = parseInt(new URLSearchParams(window.location.search).get('mark'), 10);
          if (!n || isNaN(n)) return 0;
          return Math.max(0, Math.min(this.slides.length - 1, n - 1));
        } catch (e) {
          return 0;
        }
      }

      writeMarkParam(i) {
        if (window.Shopify && window.Shopify.designMode) { this.rememberEditorIndex(i); return; }
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('mark', i + 1);
          window.history.replaceState(window.history.state, '', url.toString());
        } catch (e) {}
      }

      // Begin op een andere mark dan de eerste, zonder kleurovergang bij het laden
      setInitial(i) {
        this.slides.forEach((s, n) => {
          s.inert = n !== i;
          if (n === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        const prev = this.style.transition;
        this.style.transition = 'none';
        this.applyColors(this.slides[i]);
        void this.offsetHeight;
        this.style.transition = prev;
        this.index = i;
        if (this.currentEl) this.currentEl.textContent = i + 1;
        this.markItems.forEach((item, n) => {
          item.classList.toggle('is-current', n === i);
          if (n === i) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
        });
      }

      intro() {
        if (this.introDone) return;
        this.introDone = true;
        this.classList.add('is-ready');
        this.slides[this.index].classList.add('is-active');
        this.placeSlash(false);
        this.syncVideos();
        this.busy = true;
        this.t2 = setTimeout(() => { this.busy = false; }, this.dur + 450);
      }

      applyColors(slide) {
        this.style.setProperty('--mt-bg', slide.dataset.bg);
        this.style.setProperty('--mt-text', slide.dataset.text);
        this.style.setProperty('--mt-accent', slide.dataset.accent);
        this.classList.toggle('mt--accent-meta', slide.dataset.metaAccent === 'true');
      }

      /* ---------- Mark menu ---------- */
      updateMarks(i) {
        if (this.currentEl && this.currentEl.textContent !== String(i + 1)) {
          const dir = i > this.index ? 1 : -1;
          this.currentEl.textContent = i + 1;
          if (!this.reduced && this.currentEl.animate) {
            this.currentEl.animate(
              [
                { transform: 'translateY(' + dir * 80 + '%)', opacity: 0 },
                { transform: 'none', opacity: 1 }
              ],
              { duration: 450, easing: 'cubic-bezier(.2, .7, .2, 1)' }
            );
          }
        }
        this.markItems.forEach((item, n) => {
          item.classList.toggle('is-current', n === i);
          if (n === i) item.setAttribute('aria-current', 'step'); else item.removeAttribute('aria-current');
        });
      }

      openMarks() {
        if (!this.marks) return;
        this.marks.classList.add('is-open');
        this.marksBtn.setAttribute('aria-expanded', 'true');
        const cur = this.markItems[this.index];
        if (cur) {
          cur.scrollIntoView({ block: 'nearest' });
          cur.focus({ preventScroll: true });
        }
      }

      closeMarks(returnFocus) {
        if (!this.marks || !this.marks.classList.contains('is-open')) return;
        this.marks.classList.remove('is-open');
        this.marksBtn.setAttribute('aria-expanded', 'false');
        if (returnFocus) this.marksBtn.focus({ preventScroll: true });
      }

      marksOpen() { return !!this.marks && this.marks.classList.contains('is-open'); }

      engaged() {
        // De section vult het scherm (bovenkant staat op 0)
        return Math.abs(this.getBoundingClientRect().top) <= 8;
      }

      inRange(i) { return i >= 0 && i < this.slides.length; }

      go(target) {
        if (!this.inRange(target) || target === this.index || this.busy || !this.introDone) return;
        this.busy = true;

        const dir = target > this.index ? 1 : -1;
        const cur = this.slides[this.index];
        const next = this.slides[target];
        const hadFocus = cur.contains(document.activeElement);
        const outMs = this.reduced ? 0 : Math.round(this.dur * 0.75);

        this.updateMarks(target);
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');

        clearTimeout(this.t1); clearTimeout(this.t2);
        this.t1 = setTimeout(() => {
          cur.classList.remove('is-leaving');
          cur.setAttribute('aria-hidden', 'true');
          cur.inert = true;

          this.applyColors(next);
          next.removeAttribute('aria-hidden');
          next.inert = false;
          next.classList.add('is-active');
          this.index = target;
          this.syncVideos();
          this.placeSlash(true);
          this.writeMarkParam(target);

          if (hadFocus) {
            const btn = next.querySelector('[data-mt-go="' + (dir > 0 ? '1' : '-1') + '"]') ||
                        next.querySelector('[data-mt-go]');
            if (btn) btn.focus({ preventScroll: true });
          }

          this.t2 = setTimeout(() => { this.busy = false; }, this.dur + 450);
        }, outMs);
      }

      jump(i) {
        clearTimeout(this.t1); clearTimeout(this.t2);
        this.slides.forEach((s, n) => {
          s.classList.remove('is-leaving');
          s.classList.toggle('is-active', n === i);
          s.inert = n !== i;
          if (n === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        });
        this.applyColors(this.slides[i]);
        this.updateMarks(i);
        this.index = i;
        this.introDone = true;
        this.placeSlash(true);
        this.classList.add('is-ready');
        this.busy = false;
        this.syncVideos();
      }

      snapTo() {
        this.snapping = true;
        this.fresh = false;
        window.scrollTo({ top: window.scrollY + this.getBoundingClientRect().top, behavior: 'smooth' });
        setTimeout(() => { this.snapping = false; }, 750);
      }

      exit() {
        const bottom = window.scrollY + this.getBoundingClientRect().bottom;
        window.scrollTo({ top: bottom, behavior: 'smooth' });
      }

      /* ---------- Muis / trackpad ---------- */
      onWheel(e) {
        if (this.lbOpen) { if (!this.lbVideo.contains(e.target)) e.preventDefault(); return; }
        if (this.marksOpen()) {
          if (this.marks.contains(e.target)) return; // in de lijst scrollen
          this.closeMarks();
        }
        if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
        const dir = e.deltaY > 0 ? 1 : -1;

        // Een "nieuw" gebaar begint pas na een korte pauze in wheel-events
        clearTimeout(this.idleT);
        this.idleT = setTimeout(() => { this.fresh = true; }, 180);

        if (this.engaged()) {
          if (this.busy || this.snapping || !this.fresh) { e.preventDefault(); return; }
          const target = this.index + dir;
          if (!this.inRange(target)) return; // eerste/laatste slide: pagina mag verder scrollen
          e.preventDefault();
          if (Math.abs(e.deltaY) < 4) return;
          this.fresh = false;
          this.go(target);
          return;
        }

        if (this.snapping) { e.preventDefault(); return; }

        // Section komt in beeld: vastklikken op de bovenkant
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight;
        if ((dir > 0 && r.top > 0 && r.top < vh * 0.4) || (dir < 0 && r.top < 0 && r.top > -vh * 0.4)) {
          e.preventDefault();
          this.snapTo();
        }
      }

      /* ---------- Touch ---------- */
      onTouchStart(e) {
        if (this.lbOpen || (this.marks && this.marks.contains(e.target))) { this.ty = null; return; }
        this.ty = e.touches[0].clientY;
        this.tx = e.touches[0].clientX;
      }

      onTouchMove(e) {
        if (this.ty == null) return;
        const dy = this.ty - e.touches[0].clientY;
        const dx = this.tx - e.touches[0].clientX;
        if (Math.abs(dx) > Math.abs(dy)) return;
        if (!this.engaged()) return;
        if (this.busy || this.snapping) { e.preventDefault(); return; }
        if (this.inRange(this.index + (dy > 0 ? 1 : -1))) e.preventDefault();
      }

      onTouchEnd(e) {
        if (this.ty == null) return;
        const dy = this.ty - e.changedTouches[0].clientY;
        this.ty = null;
        if (Math.abs(dy) < 40) return;
        const dir = dy > 0 ? 1 : -1;

        if (this.engaged()) {
          if (!this.busy) this.go(this.index + dir);
          return;
        }
        const r = this.getBoundingClientRect();
        const vh = window.innerHeight;
        if ((dir > 0 && r.top > 0 && r.top < vh * 0.5) || (dir < 0 && r.top < 0 && r.top > -vh * 0.5)) {
          this.snapTo();
        }
      }

      /* ---------- Toetsenbord ---------- */
      onKey(e) {
        if (this.lbOpen) return;
        if (this.marksOpen()) {
          if (e.key === 'Escape') { e.preventDefault(); this.closeMarks(true); return; }
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            e.preventDefault();
            const n = this.markItems.indexOf(document.activeElement);
            const next = this.markItems[Math.max(0, Math.min(this.markItems.length - 1, n + (e.key === 'ArrowDown' ? 1 : -1)))];
            if (next) next.focus();
          }
          return;
        }
        if (!this.engaged()) return;
        if (/^(INPUT|TEXTAREA|SELECT|BUTTON|A|VIDEO)$/.test(e.target.tagName)) return;
        let dir = 0;
        if (e.key === 'ArrowDown' || e.key === 'PageDown') dir = 1;
        else if (e.key === 'ArrowUp' || e.key === 'PageUp') dir = -1;
        else if (e.key === ' ') dir = e.shiftKey ? -1 : 1;
        if (!dir) return;
        if (this.busy) { e.preventDefault(); return; }
        if (!this.inRange(this.index + dir)) return;
        e.preventDefault();
        this.go(this.index + dir);
      }

      /* ---------- Knoppen ---------- */
      onClick(e) {
        const play = e.target.closest('[data-mt-video]');
        if (play && this.contains(play)) { this.openLightbox(play.dataset.mtVideo, play); return; }
        if (e.target.closest('[data-mt-close]')) { this.lb.close(); return; }
        if (e.target.closest('[data-mt-marks-toggle]')) {
          if (this.marksOpen()) this.closeMarks(); else this.openMarks();
          return;
        }
        const to = e.target.closest('[data-mt-to]');
        if (to) {
          this.closeMarks(true);
          if (!this.engaged()) this.snapTo();
          this.go(parseInt(to.dataset.mtTo, 10));
          return;
        }
        const btn = e.target.closest('[data-mt-go]');
        if (!btn || !this.contains(btn)) return;
        const val = btn.dataset.mtGo;
        if (val === 'exit') { this.exit(); return; }
        if (!this.engaged()) this.snapTo();
        this.go(this.index + parseInt(val, 10));
      }

      /* ---------- Theme editor: geselecteerde slide tonen ---------- */
      onBlockSelect(e) {
        const slide = e.target.closest && e.target.closest('[data-mt-slide]');
        if (!slide || !this.contains(slide)) return;
        const i = this.slides.indexOf(slide);
        if (i > -1) {
          this.jump(i);
          this.rememberEditorIndex(i);
        }
      }

      // In de theme editor wordt de section na elke wijziging opnieuw opgebouwd.
      // We onthouden welke mark open stond, zodat de preview niet terugspringt naar mark 1.
      rememberEditorIndex(i) {
        try { sessionStorage.setItem('mt-editor-' + this.id, String(i)); } catch (e) {}
      }

      editorIndex() {
        try {
          const n = parseInt(sessionStorage.getItem('mt-editor-' + this.id), 10);
          return isNaN(n) ? 0 : Math.max(0, Math.min(this.slides.length - 1, n));
        } catch (e) {
          return 0;
        }
      }
    }

    customElements.define('mark-timeline', MarkTimeline);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
